<template>
    <section>
        <div class="container">

            <div class="text-title">Support</div>
            <p>Technical support is available from the resources shown below. It is recommended to first check for program <router-link to="/download/loopcad">updates</router-link> and review the <router-link to="/support/faqs">Frequently Asked Questions</router-link> before contacting Technical Support.</p>

            <div class="row q-col-gutter-lg items-stretch q-mt-lg">
                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/download/loopcad`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Downloads</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                Check this section for the latest updates and maintenance releases. Additional resources may also be available here for download.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/support/faqs`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Help & FAQ's</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                Our library of FAQ's provides quick access to answers to the most common questions about LoopCAD. Check here often for up to date answers on the issues you may want help with.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/support/tutorial`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Tutorials</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                Check out the online Tutorial lessons. If you are trying to learn a task or feature, this may be your quickest route.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/support/webinars`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Webinars</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                View training information, including the schedule for upcoming live Webinars. Also download past Webinars.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/support/ticket`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Email Us</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                If you have a question or comment about our software, or a suggestion for future releases, please use this online form to send it to us. We greatly appreciate your feedback.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                    <q-card class="card-product full-height cursor-pointer" clickable @click="$router.push(`/contact`)">
                        <div>
                            <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                <div class="row q-col-gutter-sm justify-center">
                                    <div class="text-subtitle1 text-weight-medium text-primary">Call Us</div>
                                </div>
                            </q-card-section>
                            <q-separator />
                        </div>
                        <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                            <div class="text-body2">
                                If you've been unable to resolve your issue or problem with the above resources, please contact LoopCAD technical support at 403.247.8566 Extension 0.
                            </div>
                        </q-card-section>
                    </q-card>
                </div>



            </div>



        </div>
    </section>
</template>
<script>

    export default {
        name: "support-home",
        components: {

        },
        data() {
            return {

            }
        },
        methods: {

        },
        computed: {

            screenSize() {
                return this.$q.screen
            },
        },
        created() {

        },
        watch: {

        },
    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";
</style>
